// extracted by mini-css-extract-plugin
export default {"brandPromo":"rJ-z","carousel":"sJ-z"};